import {createBrowserHistory} from 'history';

export function createHistory(isDev) {
  return createBrowserHistory();
}
